import {
  MdButton,
  MdDialog,
  MdDialogActions,
  MdDialogContent
} from "@torre-labs/material";
import Vue from "vue";

import AppMixin from "@/mixins/AppMixin";
import { OpportunitySimpleSummary } from "@/services/DTOs/OpportunitySimpleSummary";
import { OpportunitiesService } from "@/services/OpportunitiesService";

import LoadingLayout from "@/components/layout/loading-layout/LoadingLayout";

export default Vue.extend({
  components: {
    LoadingLayout,
    MdButton,
    MdDialog,
    MdDialogActions,
    MdDialogContent
  },
  mixins: [AppMixin],
  data() {
    return {
      opportunitiesIds: {
        "employee-full-time": ["2580", "2836", "48137", "4383"],
        "intern": ["3432"],
        "flexible-job": ["3432", "4008", "3697", "2834"]
      } as { [key: string]: string[] },
      opportunitiesList: [] as OpportunitySimpleSummary[],
    };
  },
  computed: {
    opportunityType(): string | undefined {
      return this.$route.params.opportunity;
    }
  },
  mounted() {
    if (this.opportunityType) {
      OpportunitiesService.getSummariesByIds(this.opportunitiesIds[this.opportunityType]).subscribe((opportunities) => {
        this.opportunitiesList = opportunities;
      });
    }
    this.$nextTick((this.$refs.dialog as MdDialog).open);
  },
  methods: {
    closeCandidateDialog(): void {
      (this.$refs.dialog as MdDialog).close();
      const { name, params, query } = this.$route;
      this.$router.push({ name, params, query });
    }
  }
});
